import React from "react";
import styled from "styled-components";
import { HeaderBar } from "@sonder/ui/source/styled/fragments/HeaderBar";
import {
  Scroller,
  ScrollerContent,
} from "@sonder/ui/source/styled/fragments/Scroller";
import { AddMemberButton } from "team/components/AddMemberButton";
import { TeamFilters } from "team/components/TeamFilters";

const StyledHeaderBar = styled(HeaderBar)`
  justify-content: flex-start;
  > *:not(:last-child) {
    margin-right: 0.6rem;
  }
`;

export const TeamHeader = () => (
  <Scroller>
    <ScrollerContent>
      <StyledHeaderBar>
        <AddMemberButton />
        <TeamFilters />
      </StyledHeaderBar>
    </ScrollerContent>
  </Scroller>
);
